import dashboardStyle from "../styles/Dashboard.module.css";
import styles from "../styles/MeasureLittle.module.css";
import guiaPrimaria from "../images/guiaPrimariaDesk.png";
import talleDesk from "../images/talleDeskRosa.png";
import talleAzul from "../images/tallesDeskAzul.png";
import TablaTallesDinamica from "./TablaTallesDinamica";

const GUIDE_COPY = "Elegí una prenda que te quede cómoda, medila sobre una superficie plana y compará ancho y alto antes de elegir el talle.";

const GuiaTallesModal = ({ order_id, molderia, onClose, moldingId }) => {
  return (
    <div className={dashboardStyle.modalBackground}>
      <div className={styles.guideModal}>
        <button className={dashboardStyle.closer} onClick={onClose} aria-label="Cerrar guía de talles">
          <i className="bi bi-x-lg" />
        </button>

        <div className={styles.guideContent}>
          <button type="button" className={styles.guideBackBtn} onClick={onClose}>
            <i className="bi bi-arrow-left" /> Volver
          </button>

          <div className={styles.guideHeader}>
            <span className={styles.guideStep}>Guía dinámica</span>
            <h2 className={styles.guideTitle}>
              Talles <span className={styles.guideTitleAccent}>{molderia}</span>
            </h2>
            <p className={styles.guideSubtitle}>{GUIDE_COPY}</p>
          </div>

          <div className={styles.guideIntroCard}>
            <div className={styles.guideIntroBody}>
              <span className={styles.guideIntroEyebrow}>Tip útil</span>
              <p className={styles.guideIntroTitle}>Si te da entre dos talles, elegí el más grande</p>
              <p className={styles.guideIntroText}>
                Especialmente si un ancho te coincide con un talle y el alto con otro. Así evitamos que quede corto o demasiado ajustado.
              </p>
            </div>
          </div>

          <div className={styles.guideBody}>
            <div className={styles.guideVisualCard}>
              <div className={styles.guideCardHeader}>
                <span className={styles.guideCardEyebrow}>Referencia visual</span>
                <p className={styles.guideCardTitle}>Cómo tomar ancho y alto</p>
              </div>

              <div className={styles.guideVisualImages}>
                <div className={styles.guideMeasureRefs}>
                  <img src={talleDesk} alt="Medida de ancho" className={styles.guideMeasureRef} />
                  <img src={talleAzul} alt="Medida de alto" className={styles.guideMeasureRef} />
                </div>
                <img src={guiaPrimaria} alt="Referencia de prenda" className={styles.guideGarmentRef} />
                <p className={styles.guideVisualHint}>
                  Medí con la prenda bien estirada y compará esos valores con la tabla de la derecha.
                </p>
              </div>
            </div>

            <div className={styles.guideTableCard}>
              <div className={styles.guideCardHeader}>
                <span className={styles.guideCardEyebrow}>Tabla dinámica</span>
                <p className={styles.guideCardTitle}>Compará medidas por talle</p>
              </div>
              <TablaTallesDinamica order_id={order_id} molderia={molderia} moldingId={moldingId} />
            </div>
          </div>

          <div className={styles.guideNoteCard}>
            <p className={styles.guideNoteText}>
              Las medidas pueden variar hasta 2 cm una vez confeccionadas.
            </p>
          </div>

          <div className={styles.guideFooter}>
            <button type="button" className={styles.measureSecondaryBtn} onClick={onClose}>
              Cerrar guía
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuiaTallesModal;
